import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type AiBadgeTier = 'normal' | 'pro';
export type AiBadgeVariant = 'solid' | 'outline';
export type AiBadgeSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'cosmos-ai-badge',
  templateUrl: './ai-badge.component.html',
  styleUrl: './ai-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiBadgeComponent {
  readonly tier = input<AiBadgeTier>('normal');
  readonly variant = input<AiBadgeVariant>('solid');
  readonly size = input<AiBadgeSize>('md');

  readonly label = computed(() => this.tier() === 'pro' ? 'CoSMoS AI PRO' : 'CoSMoS AI');

  readonly isPro = computed(() => this.tier() === 'pro');

  readonly hostClasses = computed(() => ({
    'ai-badge': true,
    [`ai-badge--${this.variant()}`]: true,
    [`ai-badge--${this.size()}`]: true,
    'ai-badge--pro': this.isPro(),
  }));
}
